import React from 'react'

import LetterLanding from '../LetterLanding';

import logo_target from '../../../images/letterfunnel/techonenl.webp';
import screenshot_target from '../../../images/letterfunnel/coertcoomans.webp';


export default class extends React.Component {

  // variable "competition" is optional, fallback: "jouw B2B concurrenten".
  render() {
    return <LetterLanding
      fullname="Coert Coomans"
      firstname="Coert"
      companyname="TechoneNL"
      competition="The Interstellar Group en Futureproof Group"
      logo_target={logo_target}
      screenshot_target={screenshot_target}
    />;
  }

}



// WEBPACK FOOTER //
// ./src/containers/letterfunnel/landings/coertcoomans.js